const PLAYER_PARAMS = {
  responsive: true,
  waveColor: '#A8DBA8',
  progressColor: '#3B8686',
  backend: 'MediaElement',
  barWidth: 3,
  barRadius: 3,
  cursorWidth: 2,
  height: 250,
  barGap: 3
};
const CURSOR_PLUGIN_PARAMS = {
  showTime: true,
  opacity: '1',
  customShowTimeStyle: {
    'background-color': '#333333',
    color: '#ffffff',
    padding: '4px',
    'border-radius': '3px',
    'font-size': '14px',
    'font-family': "UberMoveText, system-ui, 'Helvetica Neue', Helvetica, Arial, sans-serif"
  }
};
const VERSION = '1.0';
const ANNOTATION_TYPE = Object.freeze({
  REGION: 'REGION'
});
const MEDIA_TYPE = ({
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO'
} as const);
const VIDEO_METADATA_TYPE = ({
  FRAME_TABLE: 'frameTable',
  ACCURATE: 'accurate',
  FRAMERATE: 'framerate'
} as const);
const AUDIO_ERROR_MSG = ['Error decoding audiobuffer', 'Failed to fetch'];
export { PLAYER_PARAMS, CURSOR_PLUGIN_PARAMS, ANNOTATION_TYPE, VERSION, MEDIA_TYPE, VIDEO_METADATA_TYPE, AUDIO_ERROR_MSG };
export const READY_EVENT_NAME = 'ready';
export const STALLED_EVENT_NAME = 'stalled';
export const ERROR_EVENT = 'error';
export const WAVEFORM_READY_EVENT_NAME = 'waveform-ready';
export const TIME_UPDATE_EVENT_NAME = 'timeupdate';
export const FINISH_EVENT_NAME = 'finish';
export const CANPLAY_EVENT_NAME = 'canplay';